<template>
<div class="col-12 text-left">
    <h3 class="p-2">
        <small class="text-muted">Laporan - Order Pembelian</small>
    </h3>
    <div class="p-2 dropdown-divider"></div>
    <div class="row">
        <div class="form-group col-3">
            <label>Dari</label>
            <flat-pickr class="form-control" v-model="options.fromDate"></flat-pickr>
        </div>
        <div class="form-group col-3">
            <label>Sampai</label>
            <flat-pickr class="form-control" v-model="options.toDate"></flat-pickr>
        </div>
    </div>
    <button type="button" class="btn btn-outline-success" @click="preview">Preview <i class="fas fa-print"></i></button>
</div>
</template>

<script>
export default {
    data() {
        return {
            options: {
                fromDate: this.moment().format('YYYY-MM-DD'),
                toDate: this.moment().format('YYYY-MM-DD')
            }
        }
    },
    created() {
    },
    methods: {
        preview() {
            this.$router.push({
                name: 'appRptPurchaseOrderPrint',
                query: {
                    fromDate: this.options.fromDate,
                    toDate: this.options.toDate
                }
            })
        }
    }
}
</script>